import {all} from 'redux-saga/effects';

import {createFetchSagaLatest, createPostSagaLatest} from 'utils/sagas';

import {
  fetchTeamDetail as fetchTeamDetailAction,
  fetchTeamPermissions as fetchTeamPermissionsAction,
  fetchStaffMember as fetchStaffMemberAction,
  editTeamPermissions as editTeamPermissionsAction,
  editTeamDetails as editTeamDetailsAction,
  addTeamLocation as addTeamLocationAction,
  removeTeamLocation as removeTeamLocationAction,
  addMemberToTeam as addMemberToTeamAction,
  removeMemberFromTeam as removeMemberFromTeamAction,
  demoteTeamOwner as demoteTeamOwnerAction,
  promoteTeamOwner as promoteTeamOwnerAction,
  deleteTeam as deleteTeamAction,
  activateUser as activateUserAction,
  deactivateUser as deactivateUserAction,
  resendAdminInvitation as resendAdminInvitationAction,
  resetAdminPassword as resetAdminPasswordAction,
  setInactivityLogoutTimer as setInactivityLogoutTimerAction
} from './';
import {
  fetchTeamDetail,
  editTeamPermissions,
  editTeamDetails,
  fetchTeamPermissions,
  addMemberToTeam,
  removeMemberFromTeam,
  demoteTeamOwner,
  promoteTeamOwner,
  deleteTeam,
  removeTeamLocation,
  addTeamLocation,
  fetchStaffMember,
  activateUser,
  deactivateUser,
  resendAdminInvitation,
  resetAdminPassword,
  setInactivityLogoutTimer
} from 'sdk/teams';

function* teamsDetailSaga() {
  yield all([
    createFetchSagaLatest(fetchTeamDetailAction, fetchTeamDetail),
    createFetchSagaLatest(fetchTeamPermissionsAction, fetchTeamPermissions),
    createFetchSagaLatest(fetchStaffMemberAction, fetchStaffMember),
    createPostSagaLatest(editTeamPermissionsAction, editTeamPermissions),
    createPostSagaLatest(editTeamDetailsAction, editTeamDetails),
    createPostSagaLatest(addTeamLocationAction, addTeamLocation),
    createPostSagaLatest(removeTeamLocationAction, removeTeamLocation),
    createPostSagaLatest(addMemberToTeamAction, addMemberToTeam),
    createPostSagaLatest(removeMemberFromTeamAction, removeMemberFromTeam),
    createPostSagaLatest(demoteTeamOwnerAction, demoteTeamOwner),
    createPostSagaLatest(promoteTeamOwnerAction, promoteTeamOwner),
    createPostSagaLatest(deleteTeamAction, deleteTeam),
    createPostSagaLatest(activateUserAction, activateUser),
    createPostSagaLatest(deactivateUserAction, deactivateUser),
    createPostSagaLatest(resendAdminInvitationAction, resendAdminInvitation),
    createPostSagaLatest(resetAdminPasswordAction, resetAdminPassword),
    createPostSagaLatest(
      setInactivityLogoutTimerAction,
      setInactivityLogoutTimer
    )
  ]);
}

export default teamsDetailSaga;
